export default {"src":"/login-app/[GIT_HASH]/_next/static/media/download_for_offline.61649365.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};